"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const useKatastrMap_1 = require("../../../useKatastrMap");
const react_ui_1 = require("@pasport/react-ui");
function LayerSwitchButton({ map }) {
    const { active: isKatastr } = (0, useKatastrMap_1.useStayKatastrMap)();
    const { setKatastr, setGeo } = (0, useKatastrMap_1.useKatastrMap)(map);
    const onClick = () => {
        if (!isKatastr) {
            setKatastr();
        }
        else {
            setGeo();
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(react_ui_1.Button, { onPress: onClick, color: "light", size: "small", children: isKatastr
                ? "Vypnout katastrální mapu"
                : "Zapnout katastrální mapu" }) }));
}
exports.default = LayerSwitchButton;
